/**
 * HERBENSOL - Auto-scroll du slider Producteurs
 * Defile automatiquement le slider .slider toutes les X secondes
 * Pause au hover et lors des interactions utilisateur
 */
(function () {
  const INTERVAL_MS = 4000; // intervalle entre chaque scroll auto
  const RESUME_DELAY_MS = 6000; // delai avant reprise apres interaction

  function initProducersAutoScroll() {
    const sections = document.querySelectorAll('[id^="shopify-section"][id*="producers"]');
    sections.forEach((section) => {
      const slider = section.querySelector('.slider.slider--tablet');
      if (!slider) return;
      const slides = slider.querySelectorAll('.slider__slide');
      if (slides.length <= 1) return;

      let interval = null;
      let resumeTimeout = null;
      let isPaused = false;

      function scrollNext() {
        if (isPaused) return;
        const slideWidth = slides[0].offsetWidth + 16; // largeur + gap approx
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft + slideWidth >= maxScroll - 5) {
          // retour au debut
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
        }
      }

      function startAutoScroll() {
        stopAutoScroll();
        interval = setInterval(scrollNext, INTERVAL_MS);
      }

      function stopAutoScroll() {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      }

      function pauseAndScheduleResume() {
        isPaused = true;
        stopAutoScroll();
        clearTimeout(resumeTimeout);
        resumeTimeout = setTimeout(() => {
          isPaused = false;
          startAutoScroll();
        }, RESUME_DELAY_MS);
      }

      // Pause au hover
      slider.addEventListener('mouseenter', () => {
        isPaused = true;
        stopAutoScroll();
      });
      slider.addEventListener('mouseleave', () => {
        isPaused = false;
        startAutoScroll();
      });

      // Pause au scroll/touch utilisateur
      slider.addEventListener('touchstart', pauseAndScheduleResume, { passive: true });
      slider.addEventListener('wheel', pauseAndScheduleResume, { passive: true });

      // Pause si onglet pas actif
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoScroll();
        } else if (!isPaused) {
          startAutoScroll();
        }
      });

      // Pause si l'utilisateur prefere des animations reduites
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      // Demarrer apres un petit delai pour laisser le rendu se stabiliser
      setTimeout(startAutoScroll, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProducersAutoScroll);
  } else {
    initProducersAutoScroll();
  }
})();
